import { createSelector } from 'reselect';
import Constants from '../config/const';

const worksSelector = ({ canvas: { works } }) => works;

const workDetailsSelector = ({ workDetails }) => workDetails;

export const workSizeDetails = createSelector(
  worksSelector,
  workDetailsSelector,
  (works, workDetails) => (works || [])
    .sort((w1, w2) => Math.sign(w1.wallPictureId - w2.wallPictureId))
    .map((w) => {
      const { workSizeId, frameId, workId } = w;
      const {
        title, workSizes, authorName, landscape, isHidden
      } = workDetails[workId] || {};
      if (!workSizes) { return w; }
      const workSize = workSizes.find((ws) => ws.id === workSizeId);
      if (!workSize) { return w; }
      const {
        paperMaterial, isHidden: isWorkSizeHidden,
        displayPaperWidth, displayPaperHeight, displayPrintWidth, displayPrintHeight,
        displayPrintWidthNoMat, displayPrintHeightNoMat
      } = workSize || {};
      let option = workSize.options.find((o) => o.frameId === (frameId || null))
        || workSize.options.find((o) => o.frameId === null);
      if (!option) {
        // eslint-disable-next-line no-console
        console.log('No option found for', workSize, 'frame=', frameId);
        // first one
        [option] = workSize.options;
      }
      const {
        frameDisplayWidth, frameDisplayDepth, frame, previewWidth, previewHeight,
        zoomPreviewUrl, price, frameName, frameFinalFramedSize, frameMat, nonGlarePrice
      } = option;
      return {
        ...w,
        isHidden,
        previewWidth,
        previewHeight,
        zoomPreviewUrl,
        frameDisplayDepth,
        frameDisplayWidth,
        frameFinalFramedSize,
        frame,
        frameName,
        title,
        authorName,
        landscape,
        paperMaterial,
        displayPaperWidth,
        displayPaperHeight,
        displayPrintWidth,
        displayPrintHeight,
        displayPrintWidthNoMat,
        displayPrintHeightNoMat,
        frameMat,
        price,
        nonGlarePrice,
        isWorkSizeHidden,
        previewW: previewWidth * Constants.preview.scaleX / 100,
        previewH: previewHeight * Constants.preview.scaleY / 100
      };
    })
);

const hangingMarksSelector = ({ hangings: { hangingMarks } }) => hangingMarks;

const findMarksFor = ({ first: sFirst, second: sSecond }, marks) => {
  const kinds = [];
  marks.forEach(({ first, second, kind }) => {
    if ((first === sFirst && second === sSecond) || (second === sFirst && first === sSecond)) {
      kinds.push(kind);
    }
  });
  return kinds;
};

export const hangingVariations = createSelector(
  workSizeDetails, hangingMarksSelector,
  (sizes, hangingMarks) => {
    const sortedSizes = sizes.sort((a, b) => Math.sign(a.wallPictureId - b.wallPictureId));
    const l = sortedSizes.length;
    const res = [];
    for (let i = 0; i < l; i += 1) {
      for (let j = i + 1; j < l; j += 1) {
        const variant = {
          i0: i,
          i1: j,
          first: sortedSizes[i].wallPictureId,
          second: sortedSizes[j].wallPictureId
        };
        const kinds = findMarksFor(variant, hangingMarks || []);
        res.push({
          ...variant,
          kinds
        });
      }
    }
    return res;
  }
);

export const totalPrice = createSelector(
  workSizeDetails,
  (works) => works.reduce(
    (a, w) => a + parseFloat((w.nonGlare ? w.nonGlarePrice : w.price) || 0), 0
  )
);
